import * as actionTypes from "../actionTypes";
import {updateObject} from "../../shared/utils/updateObject";
import {
    initialChangeRamGroup,
    initialGestisciTagState,
    initialReportProblemState,
    initialSegnalazioneState,
    modifyAbilitazioneDatiInitialState
} from "./helper";

const initialState = {
    segnalazione: initialSegnalazioneState,
    operators: [],
    customerAddress: "",
    reportProblem: initialReportProblemState,
    tagsForSelectedItems: [],
    tagsForSelectedItemsFirstRender: [],
    gestisciTag: initialGestisciTagState,
    enablingClasses: [],
    enablingData: [],
    simSostituve: [],
    modifyAbilitazioneDati: modifyAbilitazioneDatiInitialState,
    loadingEnabledData: false,
    loadingEnablingClasses: false,
    loadingTagsForSelectedItems: true,
    changeRamGroup: initialChangeRamGroup,
    suspensionSimsLoading: false
}

const setCategoriesAndReferentesInSegnalazione = (state, action) => {
    let tmpReferentes = []
    action.referentes.forEach(ref => tmpReferentes.push(ref))
    action.addReferente.forEach(ref => tmpReferentes.push(ref))
    const tmpObject = {
        ...state.segnalazione,
        categoria: action.categoria,
        referentes: tmpReferentes
    }
    return updateObject(state, {segnalazione: tmpObject})
}

const setAreasInSegnalazione = (state, action) => {
    const tmpObject = {
        ...state.segnalazione,
        areas: action.areas
    }
    return updateObject(state, {segnalazione: tmpObject})
}

const setDettaglioInSegnalazione = (state, action) => {
    const tmpObject = {
        ...state.segnalazione,
        dettaglio: action.dettaglio
    }
    return updateObject(state, {segnalazione: tmpObject})
}

const clearSegnalazione = (state, action) => {
    return updateObject(state, {segnalazione: action.segnalazione})
}

const setOperators = (state, action) => {
    return updateObject(state, {operators: action.operators})
}

const clearOperators = (state) => {
    return updateObject(state, {operators: []})
}

const setCustomerAddress = (state, action) => {
    return updateObject(state, {customerAddress: action.customerAddress})
}

const clearCustomerAddress = (state, action) => {
    return updateObject(state, {customerAddress: action.customerAddress})
}

const setLoadingAddressForCustomer = (state, action) => {
    return updateObject(state, {loadingAddressForCustomer: action.loading})
}

const setLoadingOrErrorReportProblem = (state, action) => {
    return updateObject(state, {reportProblem: updateObject(state.reportProblem, {[`${action.typeOf}`]: action.value})})
}

const setGestisciTagLoading = (state, action) => {
    return updateObject(state, {gestisciTag: updateObject(state.gestisciTag, {[`${action.typeOf}`]: action.value})});
}

const addNewReferente = (state, action) => {
    let tmpReferentes = state.segnalazione.referentes
    // last 2 elements are for adding that's why we skip them
    let resList = tmpReferentes.slice(0, tmpReferentes.length - 2)
    resList.push(action.newReferente)
    resList.push(tmpReferentes[tmpReferentes.length - 2])
    resList.push(tmpReferentes[tmpReferentes.length - 1])
    let tmpSegnalazione = {...state.segnalazione, referentes: resList}
    return updateObject(state, {segnalazione: tmpSegnalazione})
}

const setCategoriesInSegnalazione = (state, action) => {
    return updateObject(state, {segnalazione: {...state.segnalazione, categoria: action.categoria}})
}

const setTagsForSelectedItems = (state, action) => {
    return updateObject(state, {
        tagsForSelectedItems: [...action.tags],
        tagsForSelectedItemsFirstRender: [...action.firstRenderTasks]
    })
}

const createNewTag = (state, action) => {
    return updateObject(state, {tagsForSelectedItems: [...state.tagsForSelectedItems, action.tag]})
}

const setLoadingTagsSelectedItems = (state, action) => {
    return updateObject(state, {loadingTagsForSelectedItems: action.loading})
}

const setEnablingClasses = (state, action) => {
    return updateObject(state, {enablingClasses: action.data})
}

const clearEnableClasses = (state) => {
    return updateObject(state, {enablingClasses: []})
}

const setLoadingEnablingClasses = (state, action) => {
    return updateObject(state, {loadingEnablingClasses: action.loading})
}

const changeSelectedEnablingClass = (state, action) => {
    return updateObject(state, {enablingClasses: action.data})
}

const setEnablingData = (state, action) => {
    return updateObject(state, {enablingData: action.data})
}

const clearEnableData = (state) => {
    return updateObject(state, {enablingData: []})
}

const setLoadingEnablingData = (state, action) => {
    return updateObject(state, {loadingEnabledData: action.loading})
}

const changeSelectedEnablingData = (state, action) => {
    return updateObject(state, {enablingData: action.data})
}

const setSimSostituve = (state, action) => {
    return updateObject(state, {simSostituve: action.data})
}

const setAbilitazioneDatiParams = (state, action) => {
    return updateObject(state, {
        modifyAbilitazioneDati: updateObject(state.modifyAbilitazioneDati, {[`${action.name}`]: action.payload})
    })
}

const setChangeRamParams = (state, action) => {
    return updateObject(state, {
        changeRamGroup: updateObject(state.changeRamGroup, {[`${action.name}`]: action.payload})
    })
}

const setSuspensionSimsLoading = (state, action) => {
    return updateObject(state, {
        suspensionSimsLoading: action.payload
    })
}

const serviceRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_CATEGORIES_AND_REFERENTE_IN_SEGNALAZIONE:
            return setCategoriesAndReferentesInSegnalazione(state, action);
        case actionTypes.GET_AREAS_IN_SEGNALAZIONE:
            return setAreasInSegnalazione(state, action);
        case actionTypes.GET_DETTAGLIO_IN_SEGNALAZIONE:
            return setDettaglioInSegnalazione(state, action);
        case actionTypes.CLEAR_SEGNALAZIONE:
            return clearSegnalazione(state, action);
        case actionTypes.SET_TAGS_FOR_SELECTED_ITEMS:
            return setTagsForSelectedItems(state, action);
        case actionTypes.LOADING_TAGS_SELECTED_ITEMS:
            return setLoadingTagsSelectedItems(state, action);
        case actionTypes.GET_OPERATORS:
            return setOperators(state, action);
        case actionTypes.CLEAR_OPERATORS:
            return clearOperators(state, action);
        case actionTypes.CREATE_TAG_SELECTED_ITEMS:
            return createNewTag(state, action);
        case actionTypes.GET_ADDRESS_FOR_CUSTOMER:
            return setCustomerAddress(state, action);
        case actionTypes.SET_LOADING_GET_ADDRESS_FOR_CUSTOMER:
            return setLoadingAddressForCustomer(state, action);
        case actionTypes.CLEAR_CUSTOMER_ADDRESS:
            return clearCustomerAddress(state, action);
        case actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM:
            return setLoadingOrErrorReportProblem(state, action);
        case actionTypes.ADD_NEW_REFERENTE:
            return addNewReferente(state, action);
        case actionTypes.GET_CATEGORIES_IN_SEGNALAZIONE:
            return setCategoriesInSegnalazione(state, action);
        case actionTypes.SET_LOADING_GESTISCI_TAG:
            return setGestisciTagLoading(state, action);
        case actionTypes.SET_ENABLING_CLASSES:
            return setEnablingClasses(state, action);
        case actionTypes.CLEAR_ENABLING_CLASSES:
            return clearEnableClasses(state, action);
        case actionTypes.SET_LOADING_ENABLING_CLASSES:
            return setLoadingEnablingClasses(state, action);
        case actionTypes.CHANGE_SELECTED_ENABLED_CLASS:
            return changeSelectedEnablingClass(state, action);
        case actionTypes.SET_ENABLING_DATA:
            return setEnablingData(state, action);
        case actionTypes.CLEAR_ENABLING_DATA:
            return clearEnableData(state, action);
        case actionTypes.SET_LOADING_ENABLING_DATA:
            return setLoadingEnablingData(state, action);
        case actionTypes.CHANGE_SELECTED_ENABLED_DATA:
            return changeSelectedEnablingData(state, action);
        case actionTypes.SET_SIM_SOSTITUVE:
            return setSimSostituve(state, action);
        case actionTypes.SET_MODIFY_ABILITAZIONE_DATI_PARAMS:
            return setAbilitazioneDatiParams(state, action);
        case actionTypes.SET_CHANGE_RAM_PARAMS:
            return setChangeRamParams(state, action);
        case actionTypes.SET_LOADING_SUSPENSION_SIMS:
            return setSuspensionSimsLoading(state, action)
        default:
            return state;
    }
}

export default serviceRequestReducer;
